import {btbIndustryNumList, industryOptionsByNum, industryOptionsByName} from './constants';
import {cloneDeep} from 'lodash';

export const getWidthAndHeight = dimension => {
    const [width, height] = dimension.split('*').map(Number);
    return [width, height];
};

const findIndustryValue = numValue => {
    const industryNum = industryOptionsByNum.find(option => option.value === numValue);

    if (industryNum) {
        // 根据找到的 label 在 industryOptions 中找对应的 value
        const industryOption = industryOptionsByName.find(option => option.label === industryNum.label);
        return industryOption ? industryOption.value : '';
    }

    return '';
};

export const getRandomMaterialParams = (data, modelType) => {
    const {industry, ratio} = data;
    const industryValue = findIndustryValue(industry);
    const tagsArray = [
        `模版中心_${ratio}`,
        modelType === 'intelForm' ? '擎舵2.0' : '组合模板'
    ];
    let params = {
        nums: 5,
        type: [
            'TEXT', 'IMAGE', 'TEMPLATE'
        ],
        ratio: `RATIO_${ratio.replace(':', '_')}`
    };
    if (industry) {
        params.industry = `${industryValue}`;
        tagsArray.push(`INDUSTRY:${industry}`);
    }
    params.tags = [tagsArray.join('&')];
    return params;
};

export const getIntelligentGenImageV2Params = (dimension, prompt, ratio) => {
    const [width, height] = dimension.split('*').map(Number);
    return {
        width,
        height,
        ratio: `RATIO_${ratio.replace(':', '_')}`,
        ratioNum: height / width,
        backgroundPrompt: prompt,
        backgroundType: 'generate',
        imageGenerateType: 'BACKGROUND_V2',
        saveStatus: false,
        targetCount: 4
    };
};

export const getCutoutParams = (mainPartInfo, prompt) => {
    return {
        saveType: false,
        hasParam: false,
        cutItem: mainPartInfo.map(i => ({
            cropMain: 1,
            prompt,
            subjectImage: i.url
        }))
    };
};

export const getTemplateSizeIndustry = template => {
    const templateType = template.type;
    const industry = template[templateType].industry.value;
    return {
        ...template[templateType].sizeControl.value,
        industry
    };
};

// 提取处理 template 的方法
export const getTemplateInfo = (template, randomObj) => {
    let templateInfo = [];
    const templateType = template.type;
    if (templateType === 'systemRandom') {
        templateInfo = randomObj.template.slice(0, template[templateType].number.value);
    }
 else {
        templateInfo = template[templateType].template.chooseList;
    }

    return templateInfo;
};

// 获取模版个数
export const getTemplateSize = template => {
    const templateType = template.type;
    if (templateType === 'systemRandom') {
        return template[templateType].number.value;
    }
    const commonLength = template[templateType].template.chooseList.length;
    const myTplLength = template[templateType].template.chooseMyTpl.length;

    return commonLength + myTplLength;
};

// 提取处理 background 的方法
export const getBackgroundInfo = (background, randomObj, modelType) => {
    if (background.type === 'systemRandom') {
        const num = modelType === 'intelForm' ? 4 : 1;
        return randomObj.background.slice(0, num);
    }
    return background[background.type].value;
};

// 提取处理 background 个数
export const getBackgroundSize = (background, modelType) => {
    if (background.type === 'systemRandom') {
        const num = modelType === 'intelForm' ? 4 : 1;
        return num;
    }
    return background[background.type].value.length;
};

// 提取处理 textValue 的方法，用于兼容B2B和非B2B的文案同时存在的情况
const getTextValue = text => {
    let textValue = [];
    if (text.textUploadList?.b2bValue) {
        textValue = textValue.concat(...text.textUploadList.b2bValue);
    }
    if (text.textUploadList?.value) {
        textValue = textValue.concat(...text.textUploadList.value);
    }

    return textValue;
};

// 提取处理 text 的方法
export const getTextInfo = (text, randomObj, formExt, modelType) => {
    if (text.type === 'systemRandom') {
        return randomObj.text.slice(0, 2);
    }

    const industry = formExt[`${modelType}Industry`];
    const isB2B = btbIndustryNumList.includes(+industry) || text.textUploadList?.b2bValue?.length;
    // let textValue = text[text.type][isB2B ? 'b2bValue' : 'value'] || [];
    let textValue = getTextValue(text);
    if (textValue.length === 0) {
        textValue = isB2B ? [{manufacturerName: ''}] : [{otherText: ''}];
    }
    return textValue;
};

// 提取处理 text 的个数
export const getTextSize = (text, formExt, modelType) => {
    const industry = formExt[`${modelType}Industry`];
    const isB2B = btbIndustryNumList.includes(+industry);

    if (text.type === 'systemRandom') {
        return isB2B ? 1 : 2;
    }

    return getTextValue(text).length;
};

export const getMainPartSize = mainPart => {
    if (!mainPart?.type) {
        return 0;
    }

    if (['mainPartPreset', 'imgUploadList'].includes(mainPart.type)) {
        return mainPart[mainPart.type].value.length;
    }

    const {prompt} = mainPart[mainPart.type].value;
    if (!prompt.length) {
        return 0;
    }
    return 4;
};

// 生成笛卡尔积数组 [[1, 2], [3, 4]] => [[1, 3], [1, 4], [2, 3], [2, 4]]
export const cartesianProduct = arrays => {
    if (arrays.length === 0) {
        return [[]];
    }
    const [first, ...rest] = arrays;
    const restProduct = cartesianProduct(rest);
    return first.flatMap(f => restProduct.map(r => [f, ...r]));
};

export const transformLayerData = data => {
    const mapping = {
        bgInfo: {label: '背景图', type: 'image'},
        mainPartInfo: {label: '产品图', type: 'image'},
        brandLogoInfo: {label: 'LOGO图', type: 'image'},
        mainText: {label: '主标题', type: 'span'},
        descText: {label: '副标题', type: 'span'},
        buttonText: {label: '按钮文案', type: 'span'},
        otherText: {label: '其他文案', type: 'span'},
        riskText: {label: '风险提示语', type: 'span'},
        businessPointB2B: {label: '主标题', type: 'span'},
        sellingPointFirst: {label: '卖点1', type: 'span'},
        sellingPointSecond: {label: '卖点2', type: 'span'},
        sellingPointThird: {label: '卖点3', type: 'span'},
        manufacturerName: {label: '厂商名称', type: 'span'}
    };
    const transformedData = {};

    for (const [key, value] of Object.entries(data)) {
        if (mapping[key]) {
            transformedData[mapping[key].label] = {
                label: mapping[key].label,
                value: value,
                type: mapping[key].type
            };
        }
    }

    return transformedData;
};

export const textKeys = [
    'mainText',
    'descText',
    'buttonText',
    'otherText',
    'riskText',
    'businessPointB2B',
    'sellingPointFirst',
    'sellingPointSecond',
    'sellingPointThird',
    'manufacturerName'
];
// 格式化高级设计表单的参数
export const getTemplateReplaceInfo = ({
    width,
    height,
    targetCount,
    bgInfo,
    mainPartInfo,
    brandLogoInfo,
    textInfo,
    formConfig
}) => {
    // 获取如果未填写需要清除的字段
    const needClearList = [];
    formConfig.forEach(item => {
        if (Array.isArray(item.needClear)) {
            needClearList.push(...item.needClear);
        }
        else if (item.needClear) {
            needClearList.push(item.name);
        }
    });

    const bgInfoUrls = bgInfo.map(item => ({
        bgInfo: item.url,
        bgDetail: {id: item.id, industry: item.industry}
    }));
    const mainPartInfoUrls = mainPartInfo.map(item => ({
        mainPartInfo: item.url,
        mainPartDetail: {id: item.id, industry: item.industry}
    }));
    const brandLogoInfoUrls = brandLogoInfo.length
        ? brandLogoInfo.map(item => ({brandLogoInfo: item.url}))
        : [{brandLogoInfo: ''}];

    const textInfos = textInfo.map(item => {
        const textItem = {};
        textKeys.forEach(key => {
            if (item[key]) {
                textItem[key] = item[key];
            }
            else if (needClearList.includes(key)) {
                textItem[key] = '';
            }
            else if (key === 'buttonText') {
                textItem[key] = '查看详情';
            }
            else if (key === 'riskText') {
                textItem[key] = '';
            }
        });
        textItem.textDetail = {
            isB2B: item.isBusiness,
            filedType: item.filedType,
            ...(item.extData || {})
        };
        return textItem;
    });
    const arrays = [
        textInfos,
        mainPartInfoUrls,
        bgInfoUrls,
        brandLogoInfoUrls
    ].filter(arr => arr.length > 0);
    const combinations = cartesianProduct(arrays);
    // 合并所有组合
    const result = combinations.map(combination => Object.assign({}, ...combination));
    const mapResult = result.map((i, index) => {
        return {
            index,
            width,
            height,
            targetCount,
            businessPoint: '',
            // AI_TEMPLATE_GEN_IMAGE
            imageGenerateType: 'AI_TEMPLATE_GEN_IMAGE',
            extData: {bgDetail: i.bgDetail, mainPartDetail: i.mainPartDetail, textDetail: i.textDetail},
            replaceLayerMap: transformLayerData(i)
        };
    });
    return mapResult;
};

export const getTemplateParams = (width, height, chooseList) => {
    const name = chooseList.join(',');
    return {
        width,
        height,
        name,
        pageNo: 1,
        pageSize: chooseList.length || 20,
        order: 'desc',
        orderBy: 'updateTime',
        statusList: ['PUBLISHED']
    };
};

// 格式化数据分析字段
const formatDataAnalysis = (ext, editInfo) => {
    const {imgTplType} = editInfo;
    if (ext.dataAnalysis != null) {
        ext.dataAnalysis.imgTplType = imgTplType;
    }
    else {
        if (imgTplType) {
            ext.dataAnalysis = {imgTplType};
        }
    }
    // 如果是模板属于文创团队，imgTplType单独设置
    let templateTags = editInfo.templateDetail?.tags || [];
    let isCultural = templateTags.includes('文创整图模版') || templateTags.includes('文创组合模版');
    if (isCultural) {
        ext.dataAnalysis.imgTplType = 'WENCHUANG';
    }

    const formData = ext.modelType === 'intelForm' ? ext.intelFormData : ext.designFormData;
    let dataAnalysis = {
        ...ext.dataAnalysis,
        formType: ext.modelType,
        templateType: ext[`${ext.modelType}Data`].template.type,
        backgroundType: formData?.background?.type,
        mainPartInfo: {},
        backgroundInfo: {},
        textInfo: {}
    };
    if (ext.modelType === 'designForm') {
        dataAnalysis.mainPartType = formData?.mainPart?.type;
        if (dataAnalysis.mainPartType === 'mainPartPreset') {
            dataAnalysis.mainPartInfo.id = editInfo.extData?.mainPartDetail?.id;
            dataAnalysis.mainPartInfo.imgType = editInfo.extData?.mainPartDetail?.industry;
        }
    }
    if (dataAnalysis.backgroundType === 'bgPreset' || dataAnalysis.backgroundType === 'systemRandom') {
        dataAnalysis.backgroundInfo.id = editInfo.extData?.bgDetail?.id;
        dataAnalysis.backgroundInfo.imgType = editInfo.extData?.bgDetail?.industry;
    }
    if (editInfo.extData?.textDetail) {
        dataAnalysis.textInfo = editInfo.extData.textDetail;
    }
    return dataAnalysis;
};

/**
 * 处理保存信息
 *
 * @param {Object} data - 数据对象
 * @param {Object} params - 参数对象
 * @returns {Object} - 返回包含基础图片信息和生成列表的对象
 */
export function handleSaveInfo(obj) {
    const {editInfoList, designParamsList, extraParams} = obj;
    if (!editInfoList?.length) {
        return {};
    }
    const paramsFirst = designParamsList[0];
    const businessPoint = paramsFirst.businessPoint || '';
    const imageGenerateType = paramsFirst.imageGenerateType || '';
    // 超过一定数量的话，提交给后端的targetCount使用前端实际合成的结果数；避免大量合成图片时统计数据的失败率太低
    const originTargetCount = paramsFirst.targetCount;
    const targetCount = originTargetCount > 20 ? editInfoList.length : originTargetCount;
    return {
        basicImageInfo: {
            height: paramsFirst.height,
            width: paramsFirst.width,
            targetCount,
            imageGenerateType,
            businessPoint,
            imageSubject: paramsFirst.mainImg || '',
            ext: JSON.stringify({
                originTargetCount,
                ...extraParams
            })
        },
        risk: true,
        generateList: editInfoList.map(item => {
            const ext = cloneDeep(extraParams);
            const {url, id, editorParams} = item;
            ext.dataAnalysis = formatDataAnalysis(ext, item);
            // 增加每张图的时长
            if (item.duration) {
                ext.dataAnalysis.duration = item.duration;
            }
            // 增加生成的目标数和实际数
            ext.dataAnalysis.originTargetCount = originTargetCount;
            ext.dataAnalysis.realCount = editInfoList.length;

            const json = JSON.parse(editorParams || '{}');
            const tplData = JSON.parse(json?.tplData || '{}');
            const {width = 0, height = 0} = tplData.templateData || {};
            return {
                url,
                templateId: id,
                generateJson: editorParams,
                width,
                height,
                ext: JSON.stringify(ext)
            };
        })
    };
};

export const getTemplateTab = template => {
    const templateType = template.type;
    return template[templateType].template.activeTab;
};

// 获取私有模版的json信息
export const getMyTemplateInfo = template => {
    if (!template) {
        return [];
    }
    let list = template.map(item => {
        const editorJsonObj = JSON.parse(item.editorJson);
        const {templateData: {layers}, editorType} = editorJsonObj;
        let info = {};
        // 新版本图片编辑器特殊处理
        if (editorType === 'newEditor') {
            const {editorJson, ...rest} = item;
            const itemInfo = {...rest, ...editorJsonObj};
            return itemInfo;
        }

        let newLayers;
        newLayers = layers.map(item => {
            let params = [{title: item.name}];
            return {
                ...item,
                params: params
            };
        });
        editorJsonObj.templateData.layers = newLayers;
        info = {
            ...editorJsonObj,
            id: item.templateId
        };
        return Object.assign({}, item, info);
    });
    return list;
};
// 是否使用瀑布流
export const getUseWaterFall = array => {
    let {width, height} = array[0];
    let result = array.every(item => {
        return item.width === width && item.height === height;
    });
    return !result;
};
// 为模版添加类型参数，区分是公共模版还是私有模版
export const addTemplateType = (array, imgTplType) => {
    let list = array.map(item => {
        return {
            ...item,
            imgTplType
        };
    });
    return list;
};

export const addTemplateIndustry = (tplList, template) => {
    let _tplList = JSON.parse(JSON.stringify(tplList));
    // 添加模板行业字段
    let industryValue = template[template.type]?.industry?.value;
    let defaultIndustry = Array.isArray(industryValue) ? industryValue[0] : industryValue;
    let industryByTplId = {};
    if (template.type === 'templateGroup') {
        template[template.type]?.template?.originTemplateList?.forEach(item => {
            let industryId = item.tagList.find(item => item.includes('INDUSTRY:'))?.split(':')[1] || defaultIndustry;
            industryByTplId[item.templateId] = industryId;
        });
    }
    _tplList.forEach(item => {
        let industryId = industryByTplId[item.templateId] || defaultIndustry;
        item.industry = industryId;
        item.isB2B = btbIndustryNumList.includes(Number(industryId));
    });
    return _tplList;
};
/**
 * @desc 将一个数组按指定的最大组大小和最小组数进行分组
 * @param {Array} arr - 需要分组的数组。
 * @param {number} maxGroupSize - 每组的最大元素数量。
 * @param {number} minGroupCount - 最少的分组数量。
 * @returns {Array} 返回一个包含分组结果的二维数组：
 */
export const splitIntoGroups = (arr, maxGroupSize, minGroupCount) => {
    const totalItems = arr.length;
    const result = [];
    // 如果元素数量小于 minGroupCount，则每个元素单独成组
    if (totalItems <= minGroupCount) {
        for (let i = 0; i < totalItems; i++) {
            result.push([arr[i]]);
        }
    } else {
        // 计算实际的组数，确保至少有 minGroupCount 组
        let groupCount = Math.max(minGroupCount, Math.ceil(totalItems / maxGroupSize));

        let index = 0;
        for (let i = 0; i < groupCount; i++) {
            // 每组的大小
            const groupSize = Math.ceil((totalItems - index) / (groupCount - i)); // 剩余元素均匀分配到剩余组
            result.push(arr.slice(index, index + groupSize));
            index += groupSize;
        }
    }
    return result;
};

